import { Feil } from '../diverse/Feil';
import { Sekvensklient } from './Sekvensklient';

const enhetUrl = '//data.brreg.no/enhetsregisteret/api/enheter';
const underenhetUrl = '//data.brreg.no/enhetsregisteret/api/underenheter';

function tellForekomster(streng, sok) {
	if (Array.isArray(sok)) {
		return sok
			.map((s) => tellForekomster(streng, s))
			.reduce(function (a, b) {
				return a + b;
			}, 0);
	}
	try {
		const escapedSokestreng = sok.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // Så brukere kan søke med spesialtegn for regex
		return ((streng || '').match(new RegExp(escapedSokestreng, 'ig')) || [])
			.length;
	} catch (error) {
		return 0;
	}
}

export class Enhetsklient {
	constructor() {
		this._sekvensklient1 = new Sekvensklient();
		this._sekvensklient2 = new Sekvensklient();
	}
	_hentEnheter(operasjon) {
		return Promise.all(
			[
				this._sekvensklient1.fetch(enhetUrl + operasjon),
				this._sekvensklient2.fetch(underenhetUrl + operasjon),
			].map((p) =>
				p
					.catch(function (e) {
						if (e instanceof Object && e.status == 404) {
							return [];
						}
						throw new Feil('Feil ved henting av enhet.').med(
							'respons',
							e
						);
					})
					.then(function (res) {
						return typeof res === 'object' &&
							res.status != 404 &&
							typeof res.json === 'function'
							? res.json()
							: null;
					})
			)
		);
	}
	hentEnhetMedOrganisasjonsnummer(organisasjonsnummer) {
		return this._hentEnheter('/' + organisasjonsnummer).then(function (
			json
		) {
			return json.filter((data) => data && data instanceof Object);
		});
	}
	hentEnheterHvorNavnInneholder(organisasjonsnavn) {
		return this._hentEnheter(
			'?navn=' + encodeURIComponent(organisasjonsnavn)
		).then(function (json) {
			return json
				.flatMap((data) => {
					const objekt = (data || {})._embedded || {};
					return objekt.enheter || objekt.underenheter || [];
				})
				.filter((data) => !!data)
				.sort(function (a, b) {
					const sok = organisasjonsnavn.trim().split(/\s+/);
					return (
						tellForekomster(b.navn, sok) -
						tellForekomster(a.navn, sok)
					);
				});
		});
	}
	laster() {
		return this._sekvensklient1.laster() || this._sekvensklient2.laster();
	}
}
